module.exports = __webpack_public_path__ + "static/media/proposta.bcf48bf7.pdf";